// // Only run on phones or small devices
// if (window.matchMedia("(max-width: 768px)").matches) {
//   document.querySelectorAll('a[href="#custom__product-variant"]').forEach(link => {
//     link.addEventListener('click', function (e) {
//       e.preventDefault();

//       // Slight delay to allow section to render or expand
//       setTimeout(() => {
//         const section = document.querySelector('#custom__product-variant');
//         if (section) {
//           section.scrollIntoView({ behavior: 'smooth', block: 'start' });
//         }
//       }, 300);
//     });
//   });
// }


document.addEventListener('DOMContentLoaded', () => {
  const anchor = document.querySelector('a[href="#custom__product-variant"], a[href="#custom__product-variant-desk"]');

  function updateAnchorHref() {
    if (!anchor) return;

    if (window.matchMedia("(min-width: 769px)").matches) {
      // Desktop
      anchor.setAttribute('href', '#custom__product-variant-desk');
    } else {
      // Mobile / Tablet
      anchor.setAttribute('href', '#custom__product-variant');
    }
  }

  // Run once on load
  updateAnchorHref();

  // Also update when screen is resized
  window.addEventListener('resize', updateAnchorHref);
});
